import { Account } from '@/core/api/collections/currentAccount';

export const calculatePerAdminBillingRateCents = (account: Account, diff: number): number | undefined => {
  if (!isPerAdmin(account) || !account.rate || !account.perAdminRate) {
    return undefined;
  }

  return account.rate + account.perAdminRate * diff;
};

const isPerAdmin = (account: Account): boolean => {
  return account.plan?.rateType === 'per_admin';
};
